.premium-program-tag {
  display: flex;
  align-items: center;
  height: 24px;
  border-radius: 4px;
}
